import { Box, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FormatAbbrDateYear } from "~/lib/date";

type PreviewSummaryTextProps = {
  previewUntil?: string | null;
};

export function PreviewSummaryText({ previewUntil }: PreviewSummaryTextProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        mb: 2,
      }}
    >
      <Typography sx={{ color: "text.primary" }}>
        This check is in{" "}
        <Typography component="span" fontWeight={700}>
          preview
        </Typography>{" "}
        {previewUntil && (
          <>
            and will become scored on{" "}
            <Typography component="span" fontWeight={700}>
              {FormatAbbrDateYear(previewUntil)}
            </Typography>
          </>
        )}
        {!previewUntil && <>and is not impacting your asset risk scores.</>}
      </Typography>
      <Tooltip
        title={
          "This is check is in preview state and is not currently affecting your asset risk scores"
        }
        arrow
        placement="right"
      >
        <InfoOutlinedIcon
          fontSize="inherit"
          sx={{
            color: "text.primary",
          }}
        />
      </Tooltip>
    </Box>
  );
}
